/**
 * @module common/components/gallery_tile
 */
import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { LoadingIndicator } from 'common/components/preloader';
import Thumbnail from 'common/components/thumbnail';

/**
 * Reusable tile component for gallery pages.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class GalleryTile extends Component {
  /*
   * Function rendering a single tile
   */
  tileRenderer(classes, thumbnailImage) {
    const { label } = this.props;
    let labelElement = null;

    if (label) {
      labelElement = (
        <div className="message">{ label }</div>
      );
    }

    return (
      <Thumbnail className={classes} image={thumbnailImage}>
        { !thumbnailImage && <LoadingIndicator /> }
        { labelElement }
      </Thumbnail>
    );
  }

  /*
   * Function rendering a stack of tiles
   */
  renderStackedTile(classes, images) {
    return (
      <div className="thumbnail-stack medium-6 large-4 columns">
        { this.tileRenderer(classes, images[0]) }
        { images[1] && <Thumbnail className="thumbnail flex border" /> }
        { images[1] && <Thumbnail className="thumbnail flex border" /> }
      </div>
    );
  }

  renderTile(classes, images) {
    if (images.length > 1) {
      return this.renderStackedTile(classes, images);
    }
    return this.tileRenderer(classes, images[0]);
  }

  render() {
    const { images, additionalClasses, onTileClicked } = this.props;
    const classes = classNames('thumbnail flex', (additionalClasses || ''));

    return (
      <div
        className="tile gallery-tile"
        onClick={onTileClicked}
      >
        { this.renderTile(classes, images || []) }
        <div className="overlay-content">
          { this.props.children }
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} images - array of thumbnails
 * @property {string} additionalClasses - extra css classes to be aplied to thumbnal
 * @property {object} label - additional label to be added to the top thumbnail
 * @property {object} children - additional markup displayed on the tile
 * @property {func} onTileClicked - function called when tile is clicked
 * @property {func} onTileEnter - function called when mouse is over the tile
 * @property {func} onTileLeave - function called when mouse is out from the tile
 */
GalleryTile.propTypes = {
  images: PropTypes.array,
  additionalClasses: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  onTileClicked: PropTypes.func,
};



// WEBPACK FOOTER //
// ./common/components/gallery_tile.jsx